<template>
    <div class="form_flex_wrap loading_top_wrap">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="form_flex_title">
            <span class="title">{{ $t('reservation_settings.section_group_management.title') }}</span>
            <span class="info mgl_auto">{{ $t('reservation_settings.section_group_management.sub_title') }}</span>
        </div>
        <div class="form_flex_cont">
            <div class="table_top_wrap">
                <b>{{ $t('reservation_settings.section_group_management.label_group') }}</b>
                <button class="btn btn_s btn_blue_line mgl_auto" @click="showGroupSettingPopup()">＋ {{ $t('common.add') }}</button>
            </div>
            <table class="table2_default">
                <colgroup>
                    <col />
                    <col width="140" />
                    <col width="95" />
                </colgroup>
                <thead>
                    <tr>
                        <th>{{ $t('reservation_settings.section_group_management.label_group_title') }}</th>
                        <th>{{ $t('reservation_settings.section_group_management.label_change_order') }}</th>
                        <th>{{ $t('reservation_settings.section_group_management.label_edit') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="(this.groups?.length ?? 0) == 0">
                        <td class="txt_center lgray_txt" colspan="3">{{ $t('reservation_settings.section_group_management.label_no_group') }}</td>
                    </tr>
                    <ReservationGroupItem
                        v-for="(item, index) in groups"
                        :key="index"
                        :item="item"
                        :index="index"
                        :groups="groups"
                        @updateOrder="updateOrder"
                        @showGroupSettingPopup="showGroupSettingPopup"
                    />
                </tbody>
            </table>
        </div>
        <div class="btn_wrap">
            <span class="editor_info mgr_auto">{{ modifiedAt }} / {{ modifier }}</span>
            <button class="btn btn_l btn_blue mgl_auto" @click="saveReservationGroups()">{{ $t('common.save') }}</button>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
const moment = require('@/util/MPMoment')

import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'
import ReservationGroupItem from '../SubViews/ReservationGroupItem.vue'
import { showGroupSetting } from '../../../../sheet-overlays'
import { sheetFilters } from '../../../../sheet-filters'
import { useQueryClient } from '@tanstack/vue-query'
import { v2ReservationGroupListQueryOptions } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-find-query'
import { v2ReservationSettingFindOneQueryOptions } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-find-one-query'
import { useV2ReservationGroupUpdateSortMutation } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-update-sort-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: updateGroupSort } = useV2ReservationGroupUpdateSortMutation()
        return { queryClient, updateGroupSort }
    },
    components: { ReservationGroupItem },
    props: {},
    data() {
        return {
            isLoading: false,
            isSaving: false,
            sheetFilters,
            originalGroups: undefined,
            groups: undefined,
            settingValue: undefined
        }
    },
    watch: {
        originalGroups: {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                const temp = deepCopy(newValue)
                this.groups = temp?.filter(t => !t.isAi)
            }
        }
    },
    computed: {
        modifiedAt: function () {
            if (this.settingValue?.groupModifiedAt == undefined) {
                return '-'
            } else {
                return moment(this.settingValue?.groupModifiedAt).toString(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
            }
        },
        modifier: function () {
            if (this.settingValue?.groupModifierID == undefined) {
                return '-'
            } else {
                if (this.settingValue.groupModifierID.type >= 3000) {
                    return this.$t('reservation_settings.section_group_management.label_modified_afterdoc')
                } else {
                    return `${this.settingValue.groupModifierID.realName} ${this.$t('reservation_settings.section_group_management.label_modified')}`
                }
            }
        }
    },
    mounted() {
        this.reqeustFetchReservationGroup()
        this.reqeustFetchReservationSetting()
    },
    methods: {
        // 아이템 순서 변경
        updateOrder(action, index) {
            let group = this.groups.splice(index, 1)[0]
            switch (action) {
                case SpaceNavigationAction.FIRST:
                    this.groups.splice(0, 0, group)
                    break
                case SpaceNavigationAction.PREVIOUS:
                    this.groups.splice(index - 1, 0, group)
                    break
                case SpaceNavigationAction.NEXT:
                    this.groups.splice(index + 1, 0, group)
                    break
                case SpaceNavigationAction.LAST:
                    this.groups.splice(this.groups.length, 0, group)
                    break
            }
        },

        showGroupSettingPopup(group) {
            if (group == undefined) {
                let index = this.sheetFilters.groups.length + 1
                group = {
                    order: index
                }
            }
            showGroupSetting(group, this.handlerUpdateGroup)
        },

        async saveReservationGroups() {
            try {
                if (this.isSaving) {
                    return
                }

                this.isLoading = true
                this.isSaving = true

                await this.requestUpdateReservationGroupSort()

                this.setToast({
                    isShow: true,
                    text: this.$t('common.label_save_success')
                })

                this.reqeustFetchReservationSetting()
            } catch (err) {
                console.log('failed to save reservation groups', err)
            } finally {
                this.isLoading = false
                this.isSaving = false
            }
        },
        // 그룹 목록 조회
        async reqeustFetchReservationGroup() {
            try {

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.originalGroups = await this.queryClient.fetchQuery(v2ReservationGroupListQueryOptions(this.hospital.selectedHospital._id))
            } catch (err) {
                console.log('reservation group find error: ', err)
            }
        },

        // 그룹 수정
        async requestUpdateReservationGroupSort() {
            let ids = this.groups.map((g, index) => ({
                _id: g._id,
                sortNum: index
            }))
            let data = { groups: ids }

            // 봉투 에러(code != 0)는 ApiError로 throw — 호출자에게 전파 (기존 throw Error와 동일)
            await this.updateGroupSort(data)
            this.$emit('groupUpdateDone')
        },

        // 예약설정 조회
        async reqeustFetchReservationSetting() {
            try {
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.settingValue = await this.queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(param))
            } catch (err) {
                console.log('reservation setting find error from group management component ', err)
            } finally {
                this.isLoading = false
            }
        },

        // 팝업을 통한 그룹 수정 후 핸들러
        handlerUpdateGroup() {
            this.reqeustFetchReservationGroup()
            this.reqeustFetchReservationSetting()
            this.$emit('groupUpdateDone')
        }
    }
}
</script>
